<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  filename: { type: String, default: '' },
  compact: { type: Boolean, default: false },
});

const { t } = useI18n();

const label = computed(
  () => props.filename || t('PLANNING.SHOW.QUOTE_EMAIL_PDF_ATTACHED')
);
</script>

<template>
  <div
    class="inline-flex max-w-full items-center gap-3 rounded-xl border border-n-slate-6 bg-white shadow-sm dark:bg-slate-900"
    :class="compact ? 'px-2.5 py-2' : 'px-3 py-2.5'"
  >
    <div
      class="relative flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-n-slate-3 dark:bg-slate-800"
      :class="compact ? 'size-10' : 'size-12'"
    >
      <Icon
        icon="i-lucide-file"
        class="text-n-slate-11"
        :class="compact ? 'size-6' : 'size-7'"
      />
      <span
        class="absolute bottom-1 rounded px-1 py-px text-[0.6rem] font-bold leading-none tracking-wide text-white bg-red-600"
      >
        PDF
      </span>
    </div>
    <div class="min-w-0 pr-1">
      <div
        class="truncate font-semibold text-n-slate-12"
        :class="compact ? 'text-xs max-w-[10rem]' : 'text-sm max-w-[14rem]'"
      >
        {{ label }}
      </div>
      <div
        class="mt-0.5 flex items-center gap-1.5 text-n-slate-11"
        :class="compact ? 'text-[0.65rem]' : 'text-xs'"
      >
        <Icon icon="i-lucide-paperclip" class="size-3 shrink-0" />
        <span>{{ t('PLANNING.SHOW.QUOTE_EMAIL_PDF_TYPE') }}</span>
      </div>
    </div>
  </div>
</template>
